import { motion } from "framer-motion";
import DetailsSection from "../molecules/StoryMagic/DetailsSection";
import Herosection from "../molecules/StoryMagic/Herosection";
import logo from "../../app/assets/images/storyMagic/overviewBg.png";
import star from "../../app/assets/images/storyMagic/starIcon.png";
import Target from "../../app/assets/images/storyMagic/Target.png";
import objective from "../../app/assets/images/storyMagic/objective.png";
import AppsTestimonials from "../molecules/AppsTestimonials/AppsTestimonials";
import CompanyLogoImage from "../molecules/CompanyLogoImage/CompanyLogoImage";
import ContactHelp from "../molecules/ContactHelp/ContactHelp";
import Footer from "../organisms/Footer/Footer";
import StoryThemeSection from "../molecules/StoryMagic/StoryThemeSection";
import SolutionsSection from "../molecules/StoryMagic/SolutionsSection";
import DreamSection from "../molecules/StoryMagic/DreamSection";

const StoryMagic = () => {
  return (
    <div className="bg-[#1E1E1E]">
      <Herosection />
      <DetailsSection
        title="Story Theme"
        heading="Overview"
        description="Story Magic is an AI-powered platform that transforms imagination into beautifully illustrated,personalized storybooks. Combining the creativity of language models and the artistry of image generation, it enables users—especially children, parents, and educators—to craft unique stories complete with custom visuals and characters in minutes."
        logoSrc={logo}
        iconSrc={star}
        className="-mt-20"
      />
      <StoryThemeSection />
      <DetailsSection
        title="Art style"
        heading="Objective"
        description="To democratize storytelling by making personalized story creation accessible to everyone—whether it's a bedtime story for a child, a custom tale for a classroom, or a creative project for aspiring authors. Story Magic aims to blend AI creativity with human imagination, empowering users to become storytellers without needing design or writing expertise."
        logoSrc={objective}
        iconSrc={Target}
        isTextLeft={true}
        className="xl:pb-20"
      />
      <SolutionsSection />
      <DreamSection />
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.1 }}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
        }}
      >
        <AppsTestimonials color="#7F51D5" bgcolor={"bg-storyMagic"} />
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.1 }}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
        }}
        className="p-4 md:p-10 md:px-36"
      >
        <CompanyLogoImage />
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.1 }}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
        }}
      >
        <ContactHelp
          title="Let's connect & achieve your business goals together"
          buttonTitle="CONTACT US"
        />
      </motion.div>

      <Footer />
    </div>
  );
};

export default StoryMagic;
